import { Link } from 'react-router-dom';
import { KeenIcon } from '@/components/keenicons';
import { toAbsoluteUrl } from '@/utils';

import { useDemo1Layout } from '../';

const HeaderLogo = () => {
  const { setMobileSidebarOpen, setMobileMegaMenuOpen, megaMenuEnabled } =
    useDemo1Layout();

  const handleSidebarOpen = () => {
    setMobileSidebarOpen(true);
  };

  const handleMegaMenuOpen = () => {
    setMobileMegaMenuOpen(true);
  };

  return (
    <div className="flex gap-1 lg:hidden items-center -ms-1">
      <Link to="/" className="shrink-0">
        <img
          src={toAbsoluteUrl('/media/app/mini-logo.png')}
          className="max-h-[25px] w-full rounded"
          alt="mini-logo"
        />
      </Link>

      <nav
        className="flex items-center"
        aria-label="Mobile navigation controls"
      >
        <button
          type="button"
          className="btn btn-icon btn-light btn-clear btn-sm contrast:text-white"
          aria-label="Open sidebar menu"
          onClick={handleSidebarOpen}
        >
          <KeenIcon icon="menu" />
        </button>

        {megaMenuEnabled && (
          <button
            type="button"
            aria-label="Open mega menu"
            className="btn btn-icon btn-light btn-clear btn-sm contrast:text-white"
            onClick={handleMegaMenuOpen}
          >
            <KeenIcon icon="burger-menu-2" />
          </button>
        )}
      </nav>
    </div>
  );
};

export { HeaderLogo };
